import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  Row,
  Badge,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import PagesContainer from "../Display/PagesContainer";
import RequiredPagesContainer from "../Display/RequiredPagesContainer";
import PageDeleteBlockersPanel from "../Display/PageDeleteBlockersPanel";
import type usePageDeleteConfirm from "../usePageDeleteConfirm";
import type { RootState } from "@/services/store";

export type DisplayPagesViewProps = {
  displaySimplePages: boolean;
  setDisplaySimplePages: (simple: boolean) => void;
  resultPages: number;
  /** Required-pages count badge: 0, 1, 2, or "..." for more. */
  resultNavFooter: number | string;
  CurrentSite: RootState["sites"]["site"];
  deletePageOperation: ReturnType<typeof usePageDeleteConfirm>["confirmDelete"];
};

const DisplayPagesView = ({
  displaySimplePages,
  setDisplaySimplePages,
  resultPages,
  resultNavFooter,
  CurrentSite,
  deletePageOperation,
}: DisplayPagesViewProps) => {
  return (
    <>
      <SimpleHeader name="Available Pages" parentName="Pages" />
      <Container className="mt--6" fluid>
        {/* SCRUM-1296: above the table and outside the tab toggle below, so a
            refused delete's referrer list survives switching tabs. */}
        <PageDeleteBlockersPanel />
        <Card>
          <CardHeader className="text-center">
            {displaySimplePages ? (
              <h3 className="mb-0 text-primary text-center">Pages</h3>
            ) : (
              <h3 className="mb-0 text-primary text-center">Navigation/Footer</h3>
            )}
            <ButtonGroup aria-label="Basic example" className="float-right" role="group">
              <Button
                className={displaySimplePages ? "active " : " "}
                color="secondary"
                type="button"
                onClick={() => setDisplaySimplePages(true)}
              >
                Custom Pages
                <Badge color="success" className="badge-md badge-circle badge-floating border-white">
                  {resultPages}
                </Badge>
              </Button>

              <Button
                className={!displaySimplePages ? "active" : " "}
                color="secondary"
                type="button"
                onClick={() => setDisplaySimplePages(false)}
              >
                Navigation/Footer
                <Badge
                  color={resultNavFooter === 2 ? "success" : "danger"}
                  className="badge-md badge-circle badge-floating border-white"
                >
                  {resultNavFooter}
                </Badge>
              </Button>
            </ButtonGroup>
          </CardHeader>

          <CardBody className="text-center">
            {displaySimplePages ? (
              <PagesContainer
                key="simple-pages"
                CurrentSite={CurrentSite}
                deletePageOperation={deletePageOperation}
              />
            ) : (
              <Row>
                <RequiredPagesContainer
                  key="required-pages"
                  deletePageOperation={deletePageOperation}
                />
              </Row>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default DisplayPagesView;
